/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentBasicInfoFragmentDoc } from './ShipmentBasicInfoFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipmentDetailsStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']
}>

export type IShipmentDetailsStatusQuery = { __typename?: 'Query' } & {
  shipment?: Types.Maybe<
    { __typename?: 'Shipment' } & Pick<
      Types.IShipment,
      | 'id'
      | 'tmsShipmentPublicUuid'
      | 'state'
      | 'specialInstruction'
      | 'hasClaims'
      | 'hasOsd'
      | 'shipperShipmentReference'
      | 'shipperMiles'
      | 'totalWeight'
      | 'totalPalletCount'
      | 'calculatedMiles'
      | 'bolReferences'
      | 'poReferences'
      | 'loadingType'
      | 'isBackhaul'
      | 'team'
    > & {
        links: { __typename?: 'ShipmentLinks' } & Pick<
          Types.IShipmentLinks,
          'starkCopyFmsShipmentUrl'
        >
        shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
          Types.IShipperApplication,
          'id' | 'carrierInstructions'
        >
        trackingOverview: { __typename?: 'TrackingOverview' } & Pick<
          Types.ITrackingOverview,
          'trackingState' | 'calculatedTrackingMethod'
        >
        rateConfirmationAgreement?: Types.Maybe<
          { __typename?: 'RateConfirmationAgreement' } & Pick<
            Types.IRateConfirmationAgreement,
            'id' | 'carrierSignature' | 'carrierSignedAt'
          >
        >
        statusDetails: { __typename?: 'ShipmentStatus' } & Pick<
          Types.IShipmentStatus,
          'detailedState' | 'pickupStatus'
        >
        firstPickup: { __typename?: 'ShipmentStop' } & Pick<
          Types.IShipmentStop,
          | 'id'
          | 'city'
          | 'stateCode'
          | 'specialInstruction'
          | 'commodity'
          | 'dropTrailer'
          | 'note'
          | 'lateReason'
          | 'project44Eta'
          | 'manualEta'
          | 'arrivedAt'
          | 'latitude'
          | 'longitude'
          | 'leftAt'
          | 'stopSequence'
          | 'stopType'
          | 'zipcode'
        > & {
            appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
              Types.IShipmentStopAppointment,
              'id' | 'timezone' | 'startAt' | 'endAt' | 'appointmentType'
            >
          }
        lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
          Types.IShipmentStop,
          | 'id'
          | 'city'
          | 'stateCode'
          | 'specialInstruction'
          | 'commodity'
          | 'dropTrailer'
          | 'note'
          | 'lateReason'
          | 'project44Eta'
          | 'manualEta'
          | 'arrivedAt'
          | 'latitude'
          | 'longitude'
          | 'leftAt'
          | 'stopSequence'
          | 'stopType'
          | 'zipcode'
        > & {
            appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
              Types.IShipmentStopAppointment,
              'id' | 'timezone' | 'startAt' | 'endAt' | 'appointmentType'
            >
          }
        stops: Array<
          { __typename?: 'ShipmentStop' } & Pick<
            Types.IShipmentStop,
            | 'id'
            | 'city'
            | 'stateCode'
            | 'specialInstruction'
            | 'commodity'
            | 'dropTrailer'
            | 'note'
            | 'lateReason'
            | 'project44Eta'
            | 'manualEta'
            | 'arrivedAt'
            | 'latitude'
            | 'longitude'
            | 'leftAt'
            | 'stopSequence'
            | 'stopType'
            | 'zipcode'
          > & {
              appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                Types.IShipmentStopAppointment,
                'id' | 'timezone' | 'startAt' | 'endAt' | 'appointmentType'
              >
            }
        >
        equipment: { __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id' | 'name'>
        characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
          Types.IShipmentCharacteristics,
          'hot' | 'mustGo' | 'haltClaimsBilling' | 'haltClaimsInvoicing'
        >
        shipperTrackingSegment?: Types.Maybe<
          { __typename?: 'ShipperTrackingSegment' } & Pick<
            Types.IShipperTrackingSegment,
            'id' | 'description' | 'level'
          >
        >
      }
  >
}

export const ShipmentDetailsStatusDocument = gql`
  query ShipmentDetailsStatus($id: ID!) {
    shipment(id: $id) {
      ...ShipmentBasicInfo
      id
      tmsShipmentPublicUuid
      links {
        starkCopyFmsShipmentUrl
      }
      state
      specialInstruction
      hasClaims
      hasOsd
      shipperApplication {
        id
        carrierInstructions
      }
      trackingOverview {
        trackingState
        calculatedTrackingMethod
      }
      rateConfirmationAgreement {
        id
        carrierSignature
        carrierSignedAt
      }
      statusDetails {
        detailedState
        pickupStatus
      }
    }
  }
  ${ShipmentBasicInfoFragmentDoc}
`

/**
 * __useShipmentDetailsStatusQuery__
 *
 * To run a query within a React component, call `useShipmentDetailsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentDetailsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentDetailsStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShipmentDetailsStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    IShipmentDetailsStatusQuery,
    IShipmentDetailsStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShipmentDetailsStatusQuery, IShipmentDetailsStatusQueryVariables>(
    ShipmentDetailsStatusDocument,
    options
  )
}
export function useShipmentDetailsStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IShipmentDetailsStatusQuery,
    IShipmentDetailsStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShipmentDetailsStatusQuery, IShipmentDetailsStatusQueryVariables>(
    ShipmentDetailsStatusDocument,
    options
  )
}
export type ShipmentDetailsStatusQueryHookResult = ReturnType<typeof useShipmentDetailsStatusQuery>
export type ShipmentDetailsStatusLazyQueryHookResult = ReturnType<
  typeof useShipmentDetailsStatusLazyQuery
>
export type ShipmentDetailsStatusQueryResult = Apollo.QueryResult<
  IShipmentDetailsStatusQuery,
  IShipmentDetailsStatusQueryVariables
>
